module.exports = __webpack_public_path__ + "static/media/  (11).0a87239b.jpg";